import { Link } from 'react-router-dom'
import styles from './AccordionNav.module.css'

const AccordionNav = ({ menuItem }) => {

    return (
        <li className={styles.liNavBar}>
            <div className={styles.accordioncontent}>
                <Link
                    title={menuItem.contentdescription}
                    className={styles.accordionlinks}
                    target={menuItem.contentlink && (menuItem.contentlink.toLowerCase().includes('elmah')) ? '_blank' : '_self'}
                    to={menuItem.contentlink}
                >
                    <label className={styles.accordionlabel}>
                        {menuItem.contentheader}
                    </label>
                </Link>

            </div>
        </li>
    );
};

export default AccordionNav;